import docsearch from '@docsearch/js';
import '@docsearch/css';

document.addEventListener('turbo:load', function(event) {
  docsearch({
    container: '#docsearch',
    appId: '3YNH2Z855B',
    indexName: 'production-docs',
    apiKey: '565db5bae08fc4ebc38f7d82be2c802b',
    transformItems(items) {
      return items.map(item => {
        item.url = item.url.replace('http://customer-docs.local', '');
        item.url = item.url.replace('http://master.docs.haproxy.com', '');
        item.url = item.url.replace('http://customer.docs.haproxy.com', '');
        return item;
      });
    }
  });
});